// import { getRouteUrl } from '@/router';
import type { LocationQueryRaw, RouteLocationRaw, Router, RouteRecordRaw } from 'vue-router';
import { TMiddlePageAppQuery, TMiddlePageOpenAppQuery } from './middle-page-open-app';
import { routeNameMiddleApp, routeNameOpenUrl } from './middle-page-open-app.constants';
import MiddlePageOpenApp from './middle-page-open-app.vue';
import MiddlePageOpenUrl from './middle-page-open-url.vue';

export const middlePageOpenAppRouter: RouteRecordRaw[] = [
  {
    path: '/middle-page-open-app',
    name: routeNameMiddleApp,
    component: MiddlePageOpenApp,
  },
  {
    path: '/open-url',
    name: routeNameOpenUrl,
    component: MiddlePageOpenUrl,
  },
];

export const getMiddlePageAppUrl = (router: Router, query: TMiddlePageAppQuery) => {
  const baseUrl = getRouteUrl(router, routeNameMiddleApp, query as any as Record<string, string | number>);

  const { origin, pathname } = location;

  return `${origin}${pathname}${baseUrl}`;
};

/** 跳转去应用中间页，创建|打开应用 */
export const getToMiddlePageAppParams = (query: TMiddlePageOpenAppQuery): RouteLocationRaw => {
  const _query = query as any as LocationQueryRaw;
  return {
    name: routeNameMiddleApp,
    query: _query,
  };
};

function getRouteUrl(router: Router, name: string, query: Record<string, string | number>) {
  const routeUrl = router.resolve({
    name,
    query,
  });

  return routeUrl.href;
}
